// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

import { Fragment } from 'react';

import HeroSection from './HeroSection/HeroSection';
import ProblemSolutionSection from './ProblemSolutio/ProblemSolutio';
import KeyFeaturesSection from './KeyFeatures/KeyFeatures';
import AppPreview from './AppPreview/AppPreview';
import HowItWorksSection from './HowItWorks/HowItWorks';

export const Home = () => {
	return (
		<Fragment>
			<HeroSection />
			<ProblemSolutionSection />
			<KeyFeaturesSection />
			<AppPreview />
			<HowItWorksSection />
		</Fragment>
	);
};
